<template>
  <f7-list-item
    link="#"
    class="dark_mode"
    :title="$t('settings.theme.title')"
    @click="openThemeActions"
  >
    <template #media>
      <f7-icon material="dark_mode" />
    </template>
    <template #footer>
      <span class="theme-current-label">{{ currentLabel }}</span>
    </template>
  </f7-list-item>
</template>

<script setup>
import { computed } from "vue";
import { f7 } from "framework7-vue";
import { themeMode, setThemeMode } from "../../js/composables/useTheme.js";
import { useHaptics } from "../../js/composables/useHaptics.js";
import i18n from "../../js/i18n.js";

// F7-vue's <f7-list> inspects child vnodes via `type.name` and crashes on
// unnamed script-setup components (type falls back to the component object).
// A name containing "f7-list-item" makes the list treat this component as a
// list item and render it inside its <ul>.
defineOptions({ name: "f7-list-item-wrapper" });

const { t } = i18n.global;
const haptic = useHaptics();

const currentLabel = computed(() => t(`settings.theme.${themeMode.value}`));

function openThemeActions(e) {
  haptic.light();
  const options = ["system", "light", "dark"];
  const buttons = [
    options.map((mode) => ({
      text: t(`settings.theme.${mode}`),
      checked: themeMode.value === mode,
      onClick: () => {
        haptic.light();
        setThemeMode(mode);
      },
    })),
    [{ text: t("common.cancel"), bold: true }],
  ];
  const actions = f7.actions.create({
    // openIn: "sheet",
    convertToPopover: true,
    closeOnEscape: true,
    closeByOutsideClick: true,
    buttons,
    targetEl: f7.$('.dark_mode'),
    on: {
      closed: () => actions.destroy(),
    },
  });
  actions.open();
}
</script>

<style scoped>
.theme-current-label {
  font-size: 13px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
</style>
